import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { type UnsubscribeContactsApiArg } from '@/__generated/es-api'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useUnsubscribeAllContacts = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [unsubscribeContacts, res] = esApi.endpoints.unsubscribeContacts.useMutation()

  const unsubscribeAllContactsFromCampaign = useCallback(
    async (campaignId: number) => {
      const body: UnsubscribeContactsApiArg['body'] = {
        contacts: {
          allContactsAreSelected: true,
        },
      }

      try {
        const result = await unsubscribeContacts({
          orgId: orgId.toString(),
          campaignId: campaignId.toString(),
          body,
        }).unwrap()

        dispatch(
          createNotification({
            'unsubscribe-campaign': {
              type: 'success',
              message: 'All contacts unsubscribed from campaign successfully.',
            },
          }),
        )
        return result
      } catch (error) {
        const fallbackMessage =
          'A problem occurred with trying to unsubscribe all contacts from the campaign. Please try again later.'
        dispatch(
          createNotification({
            'unsubscribe-campaign': {
              type: 'error',
              message: getErrorMessage(error, fallbackMessage),
            },
          }),
        )
        return undefined
      }
    },
    [dispatch, orgId, unsubscribeContacts],
  )

  return [unsubscribeAllContactsFromCampaign, res] as const
}
